import React, { useContext } from "react";
import { Link,Outlet } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import AdminContext from "./AdminDashContext";

export default function AdminAccount(){
  const {adminData}=useContext(AdminContext)
    return (
        <div>
        <div className=" flex flex-row gap-x-4">
        <Link
              to="change"
              className="block text-gray-700 hover:text-blue-500 mb-2"
            >
             <FontAwesomeIcon icon={faTachometerAlt}/>Account
            </Link>
            <Link
              to="logout"
              className="block text-gray-700 hover:text-blue-500"
            >
             <FontAwesomeIcon icon={faSignOut}/> Logout
            </Link>     
        </div>
        <div className=" flex flex-col">
            {adminData?.profile?<img src={adminData?.profile} alt={adminData?.username} className="w-12 h-12 rounded-full"/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full"/>}
            {adminData?.username?<p className=" relative flex">{adminData?.username}</p>:<p>Loading username...</p>}
            {adminData?.name?<p className=" relative flex">{adminData?.name}</p>:<p>Loading Name ...</p>}
            {adminData?.email?<p>{adminData?.email}</p>:<p>Loading Email ...</p>}
        </div>
        
            <Outlet/>       
      </div>
    )
}